<template>
  <div>
    <div v-if="maintenance" class="bg-red-600 text-white p-5 flex items-center">
      <BaseIcon name="alert-circle" class="text-red-200" />
      <div class="mx-2">
        Er vindt
        <strong>serveronderhoud</strong> plaats. Probeer het later nogeens.
      </div>
    </div>
    <div class="lg:flex w-full h-full min-h-screen">
      <div class="lg:w-1/2 bg-gray-800 text-white">
        <div class="mx-auto max-w-md pt-8 lg:pt-12">
          <a href="https://smallbee.nl" class="text-white">
            <Logo height="28" class="mx-auto mt-3" />
          </a>
        </div>
        <div class="text-gray-100 text-center pb-8 pt-2">Sales &amp; CRM zonder toeters en bellen</div>
        <div class="hidden lg:block mt-24 max-w-md mx-auto text-center">
          <p class="text-3xl text-gray-400 leading-snug">
            Smallbee geeft ons grip op onze Sales &amp; CRM activiteiten
          </p>
          <router-link
            :to="{ name: 'register' }"
            class="btn btn-black inline-block text-xl mt-4 shadow px-6"
          >Probeer gratis</router-link>
        </div>
      </div>
      <div class="lg:w-1/2 p-6">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/auth";
import Logo from "@/components/Logo";

export default {
  components: {
    Logo
  },

  data() {
    return {
      maintenance: false
    };
  },

  created() {
    auth.csrf().catch(error => {
      if (error.response.status == 503) {
        this.maintenance = true;
      }
    });
  }
};
</script>